'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidAlarmClock = function IoAndroidAlarmClock(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm36.9 9.8l-2.1 2.5-7.7-6.4 2.2-2.5z m-23.6-3.9l-7.6 6.4-2.2-2.5 7.6-6.5z m7.8 7.6v8.7l6.6 3.9-1.2 2.1-7.9-4.8v-9.9h2.5z m-0.9-6.6c8.3 0 15.1 6.7 15.1 14.9s-6.8 14.9-15.1 14.9c-8.3 0-15.1-6.7-15.1-14.9s6.8-14.9 15.1-14.9z m0 26.5c6.4 0 11.7-5.1 11.7-11.6 0-6.4-5.3-11.6-11.7-11.6s-11.7 5.2-11.7 11.6 5.3 11.6 11.7 11.6z' })
        )
    );
};

exports.default = IoAndroidAlarmClock;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-alarm-clock.js
// module id = 1803
// module chunks = 0